import Reflux from "reflux";
import ActionUtil from "shared/util/ActionUtil";
import WebUtil from "okpay/util/WebUtil";

const Actions = Reflux.createActions({
	changeBillingType: {},
	rejectBillingInfo: {},
	updateCfs: {},
	open: {},
	close: {},
	enableFakePayment: {},
	updateField: {},

	switchSelectedOption: {},

	confirmPaypal: {},
	confirmPurchase: ActionUtil.getAsyncTemplate(),
});

ActionUtil.listen(Actions.confirmPurchase, WebUtil.confirmPurchase);

export default Actions;



// WEBPACK FOOTER //
// ./src/reflux/okpay/actions/Actions.js